import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import CommentIcon from "@mui/icons-material/Comment";

import TablePagination from "@mui/material/TablePagination";
import TableFooter from "@mui/material/TableFooter";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import ClearIcon from "@mui/icons-material/Clear";
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined';
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

import { useTheme } from "@mui/material/styles";
import Modal from "../../components/Modal";
import DeleteDialog from "../../components/DeleteDialog";
import VerificarUltimoAdjunto from "../../commons/VerificarUltimoAdjunto";
import VerificarUltimoAdjunto2 from "../../commons/VerificarUltimoAdjunto";

import api from "../../service/api";
import { setError, setSuccess } from "../../reducers/appSlice";

import Accion from "../../components/Accion";

const TablePaginationActions = (props) => {
  const theme = useTheme();

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const validationSchema = Yup.object().shape({
  numero: Yup.number().required("Requerido"),
});

const validationSchema2 = Yup.object().shape({
  folios: Yup.number().required("Requerido"),
});

const Agregados = (props) => {
  const dispatch = useDispatch();
  const [idAgregado, setIdAgregado] = useState(0);
  const [asunto, setAsunto] = useState("");
  const [numero, setNumero] = useState();
  const [folio, setFolio] = useState("");
  const [soporte, setSoporte] = useState("");
  const [tema, setTema] = useState("");
  const [situacion, setSituacion] = useState("");
  const [mensajeArhivado, setMensajeArchivado] = useState("");
  const [observacion, setObservacion] = useState("");
  const [tipo, setTipo] = useState("EXPEDIENTE");
  const [labelTipo, setLabelTipo] = useState("Número de expediente");
  const [tituloTablaTipo, setTituloTablaTipo] = useState("Expedientes");
  const [aclaracion, setAclaracion] = useState("expediente");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [agregados, setAgregados] = useState([]);
  const [openNuevoAgregado, setOpenNuevoAgregado] = React.useState(false);
  const [openDesglosar, setOpenDesglosar] = React.useState(false);
  const [openObservacion, setOpenObservacion] = React.useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitting2, setSubmitting2] = useState(false);
  const [verifica, setVerifica] = useState(false);
  const [verificaDesglose, setVerificaDesglose] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const verficarElFirmado = () =>{
    //aca van las acciones del si
    limpiarDatosAgregados();
    setOpenNuevoAgregado(true);
    setVerifica(false);
 };

 const verficarElFirmado2 = () =>{
  //aca van las acciones del si
    setOpenDesglosar(true);
    setVerificaDesglose(false);

};

 const verficarElFirmadoCancelar = () =>{
   setVerifica(false);
};

const verficarElFirmadoCancelar2 = () =>{
  setVerificaDesglose(false);
};

  const formik = useFormik({
    initialValues: {
      numero: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setSubmitting(true);
      if (idAgregado === 0) {
        dispatch(setError("Debe realizar la búsqueda del tramite."));
        setSubmitting(false);
      } else {
        if (soporte !== props.soporte) {
          dispatch(
            setError(
              "Sólo es posible agregar un " + aclaracion + " " + props.soporte
            )
          );
          setSubmitting(false);
        } else {
          setSubmitting(true);
          let datos = {
            idPrincipal: props.id,
            idAgregado: idAgregado,
          };
          api
            .guardarAgregado(datos)
            .then((res) => {
              formik.handleReset();
              setSubmitting(false);
              dispatch(setSuccess("Trámite agregado correctamente."));
              setTimeout(() => {
                setOpenNuevoAgregado(false);
                props.actualizarDatos();
                buscarAgregadosTramites();
                setSubmitting(false);
              }, 1000);
            })
            .catch((e) => {
              console.log(e.response.data.detalle);
              dispatch(setError(e.response.data.error));
              setSubmitting(true);
            });
        }
      }
    },

    onReset: () => {
      limpiarDatosAgregados();
    },
  });

  const formik2 = useFormik({
    initialValues: {
      folios: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      setSubmitting2(true);
      let datos = {
        idAgregado: idAgregado,
        folios: values.folios
      };
      api
        .guardarDesglose(datos)
        .then((res) => {
          formik2.handleReset();
          setSubmitting2(false);
          setTimeout(() => {
            setOpenDesglosar(false);
            props.actualizarDatos();
            buscarAgregadosTramites();
          }, 1000);
        })
        .catch((e) => {
          console.log(e.response.data.detalle);
          dispatch(setError(e.response.data.error));
          setSubmitting2(false);
        });
    },

    onReset: () => {
      setSubmitting2(false);
    },
  });

  const handleChangeButtonVerde = () => {
    if(props.soporte === 'DIGITAL'){
      setVerifica(true);
    }else{
      limpiarDatosAgregados();
      setOpenNuevoAgregado(true);
      setVerifica(false);
    }
    
  };

  const handleCloseDesglosar = () => {
    formik2.handleReset();
    setOpenDesglosar(false);
  };

  const handleCloseNuevoAgregado = () => {
    formik.handleReset();
    setOpenNuevoAgregado(false);
  };

  const handleCloseObservacion = () => {
    setOpenObservacion(false);
  };

  const verObservacion = (observacion) => {
    setObservacion(observacion);
    setOpenObservacion(true);
  };

  const desglosar = (id, nro) => {
    setIdAgregado(id);
    setNumero(nro);
    if(props.soporte === 'DIGITAL'){
      setVerificaDesglose(true);
    }else{
      setOpenDesglosar(true);
      setVerificaDesglose(false);
    }
    
  };

  const handleDeleteAgregacion = (id) => {

    let filtro = {
      idAgregado: id,
    };
    api
      .eliminarAgregado(filtro)
      .then((res) => {
        dispatch(setSuccess("Agregación eliminada con éxito."));
        formik.handleReset();
        setTimeout(() => {
          buscarAgregadosTramites();
          props.actualizarDatos();
        }, 1500);
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      });
  };


  const handleDeleteDesglose = (id) => {

    let filtro = {
      idDesglose: id,
    };

    api
      .eliminarDesglose(filtro)
      .then((res) => {
        dispatch(setSuccess("Desglose eliminado con éxito."));
        formik.handleReset();
        setTimeout(() => {
          buscarAgregadosTramites();
          props.actualizarDatos();
        }, 1500);
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      });
  };


  const handleNumeroTramite = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarTramite(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarTramite(event.target.value);
    } else {
      limpiarDatosAgregados();
    }
  };

  const handleChangeTextField = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleChangeTextField2 = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik2.setFieldValue(event.target.id, event.target.value);
    }
  };

  const limpiarDatosAgregados = () => {
      setIdAgregado(0);
      setAsunto("");
      setTema("");
      setObservacion("");
      setFolio("");
      setSoporte("");
      setSituacion("");      
      setMensajeArchivado("");

      if (props.situacion.indexOf("Está ARCHIVADO")!== -1) {
          if(props.tipo !== null){ 
            setMensajeArchivado("ADVERTENCIA: el expediente principal se encuentra archivado. Si continuás será recirculado.");
          }
          if(props.tipo === null){ 
            setMensajeArchivado("ADVERTENCIA: el trámite principal se encuentra archivado. Si continuás será recirculado.");
          }      
      }
      setSubmitting(true);
  }

  const buscarTramite = (nro) => {
    limpiarDatosAgregados();
    
    if (nro !== "") {
      let filtro = {
        nroExpediente: props.tipo !== null ? nro : null,
        nroTramite: props.tipo === null ? nro : null,
        digital: null,
        archivado: null,
        tipoTramite: props.tipo !== null ? 'expediente':'tramite',
        codigoTema: null,
        asunto: null,
        codigoOrganismoGenerador: null,
        iniciadores: null,
        fechaDesde: null,
        fechaHasta: null,
      };

      if (props.numero !== nro) {
        api
          .consultaMulticriterios(filtro)
          .then((res) => {
            consultarTramiteId(res.data[0].id);
            setSubmitting(false);
          })
          .catch((e) => {
            dispatch(setError("Error. Trámite inexistente"));
            setSubmitting(true);
          });
      } else {
        dispatch(
          setError(
            "No podés agregar un " + aclaracion + " a sí mismo."
          )
        );
        setSubmitting(true);
      }
    } else {
      dispatch(setError("Debe ingresar el número que se desea agregar"));
      setSubmitting(true);
    }
  };

  const consultarTramiteId = (id) => {
    limpiarDatosAgregados();

    let filtro = {
      id: id,
    };
    api
      .buscarTramiteId(filtro)
      .then((res) => {
        setIdAgregado(res.data.tramite[0].id);
        setAsunto(res.data.tramite[0].asunto);
        setTema(res.data.tramite[0].tema);
        setObservacion(res.data.tramite[0].observacion);
        setFolio(res.data.tramite[0].cant_folios);
        setSoporte(
          res.data.tramite[0].soporte === "DIGITAL" ? "DIGITAL" : "PAPEL"
        );
        setSituacion(res.data.situacion);

        if (res.data.situacion.indexOf("Está ARCHIVADO")!== -1) {
          if(res.data.tramite[0].numero_expediente!== null){
            setMensajeArchivado("ADVERTENCIA: el expediente que querés agregar se encuentra archivado. Si continuás será recirculado.");
          }

          if(res.data.tramite[0].numero_expediente=== null){
            setMensajeArchivado("ADVERTENCIA: el trámite que querés agregar se encuentra archivado. Si continuás será recirculado.");
          }          
        }

      })
      .catch((e) => {
        console.log("Error al buscar el trámite por ID");
      });
  };

  const TableCellHead = styled(TableCell)(({ theme }) => ({
    color: "#3c4b64",
  }));

  const buscarAgregadosTramites = async () => {
    try {
      let filtro = {
        tra_padre_id: props.id,
      };
      let res = await api.buscarAgregadosTramites(filtro);
      setAgregados(res.data);
    } catch (e) {
      console.log("error al listar agregados");
    }
  };

  useEffect(() => {
    buscarAgregadosTramites();
    if (props.tipo !== null) {
      setTipo("EXPEDIENTE");
      setLabelTipo("Número de expediente");
      setTituloTablaTipo("Expedientes");
      setAclaracion("expediente");
      if (props.situacion.indexOf("Está ARCHIVADO")!== -1) {
        setMensajeArchivado("ADVERTENCIA: el expediente principal se encuentra archivado. Si continuás será recirculado.");
      }
    } else {
      setTipo("TRÁMITE INTERNO");
      setLabelTipo("Número de trámite interno");
      setTituloTablaTipo("Trámites internos");
      setAclaracion("trámite interno");
      if (props.situacion.indexOf("Está ARCHIVADO")!== -1) {
        setMensajeArchivado("ADVERTENCIA: el trámite principal se encuentra archivado. Si continuás será recirculado.");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  return (
    <Grid color="primary">
      <Grid container sx={{ display: { xs: "none", sm: "block" } }}>
        <Grid item xs={12} align="right" sx={{ marginBottom: 2 }}>
          <Accion funcion={props.funcion} accion="Alta agregado">
            <Button
              variant="verde"
              onClick={handleChangeButtonVerde}
              endIcon={<AddIcon />}
            >
              Nuevo
            </Button>
          </Accion>
        </Grid>
      </Grid>
      <Grid container sx={{ display: { xs: "block", sm: "none" } }} align="right">
        <Accion funcion={props.funcion} accion="Alta agregado">
          <IconButton
            title="Nuevo"
            size="medium"
            sx={{
              color: "#fff",
              backgroundColor: "#799F4F",
              "&:hover": { color: "#fff", backgroundColor: "#546f37" },
              margin: 1,
            }}
            onClick={handleChangeButtonVerde}
          >
            <AddIcon />
          </IconButton>
        </Accion>
      </Grid>

      <TableContainer>
        <Table
          aria-label="tabla agregados"
          sx={{ border: "1px solid #dee2e6" }}
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCellHead padding="normal">
                <b>{tituloTablaTipo} agregados</b>
              </TableCellHead>
              <TableCellHead align="center" padding="normal">
                <b>Fecha de la agregación</b>
              </TableCellHead>
              <TableCellHead padding="normal">
                <b>Organismo que agregó</b>
              </TableCellHead>
              <TableCellHead padding="normal">
                <b>Situación</b>
              </TableCellHead>
              <TableCellHead align="center" padding="normal">
                <b>Acciones</b>
              </TableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {agregados
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((agregado, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={
                      index % 2 === 0
                        ? { backgroundColor: "#f2f2f2" }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    <TableCell align="left" width="150">{agregado.numero_expediente_agegado !== null &&
                      agregado.numero_expediente_agegado !== ""
                      ? agregado.numero_expediente_agegado
                      : agregado.numero_tramite_agegado}
                    </TableCell>
                    <TableCell align="center" width="100">
                      {agregado.fecha}
                    </TableCell>
                    <TableCell align="left" width="300">
                      {agregado.organismo}
                    </TableCell>
                    <TableCell align="left" width="200">
                      {agregado.situacion}
                    </TableCell>
                    <TableCell align="center" width="130">
                      <>
                        <IconButton
                          title="Ver observaciones"
                          size="small"
                          onClick={() => verObservacion(agregado.observacion)}
                          disabled={
                            agregado.observacion !== null &&
                              agregado.observacion !== ""
                              ? false
                              : true
                          }
                        >
                          <CommentIcon fontSize="small" />
                        </IconButton>

                        <Accion funcion={props.funcion} accion="Registrar_desgloses">
                          <IconButton
                            title="Desglosar"
                            size="small"
                            onClick={() => desglosar(agregado.id, agregado.numero_expediente_agegado)}
                            disabled={(agregado.desglose_id !== null &&
                              agregado.desglose_id !== "") || (props.soporte === "DIGITAL")
                              ? true
                              : false}
                          >
                            <DeviceHubOutlinedIcon fontSize="small" />
                          </IconButton>
                        </Accion>
                        {agregado.puede_borrar === "S" ? (
                          agregado.desglose_id !== null && agregado.desglose_id !== "" ? (
                            <Accion funcion={props.funcion} accion="Baja desglose">
                              <DeleteDialog
                                size="small"
                                handleDelete={() => handleDeleteDesglose(agregado.desglose_id)}
                                data={props.agregados}
                              />
                            </Accion>
                          ) : (
                              <Accion funcion={props.funcion} accion="Baja desglose">
                                <DeleteDialog
                                  size="small"
                                  handleDelete={() => handleDeleteAgregacion(agregado.id)}
                                  data={props.agregados}
                                />
                              </Accion>
                            )
                        ) : (
                            <Accion funcion={props.funcion} accion="Baja desglose">
                              <IconButton
                                title="Eliminar"
                                size="small"
                                disabled
                              >
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                              </IconButton>
                            </Accion>
                          )}
                      </>
                    </TableCell>
                  </TableRow>
                );
              })}

            {agregados.length === 0 ? (
              <TableRow>
                <TableCell colSpan="6" align="center">
                  <Typography variant="aclaracion">Sin Agregados</Typography>
                </TableCell>
              </TableRow>
            ) : (
                ""
              )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "Todos", value: agregados.length }]}
                count={agregados.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Modal open={openNuevoAgregado} handleClose={handleCloseNuevoAgregado}>
        <form
          id="formularioAgregarAgregado"
          name="formularioAgregarAgregado"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 1 }}>
              <Typography variant="titulo">AGREGAR {tipo}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4}>
              <TextField
                id="numero"
                name="numero"
                label={labelTipo}
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{ maxLength: 8 }}
                value={formik.values.numero}
                onChange={handleChangeTextField}
                onBlur={handleNumeroTramite}
                onKeyDown={handleNumeroTramite}
                error={formik.touched.numero && Boolean(formik.errors.numero)}
                helperText={formik.touched.numero && formik.errors.numero}
              />
            </Grid>
          </Grid>
          <br></br>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <Card>
                <CardActionArea>
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="cuerpo">
                            <b>Asunto:</b> {asunto}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="cuerpo">
                            <b>Tema:</b> {tema}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6}>
                        <Box>
                          <Typography variant="cuerpo">
                            <b>Soporte:</b> {soporte}
                          </Typography>
                        </Box>
                      </Grid>
                      {(folio !== "") & (folio !== null) ? (
                        <Grid item xs={12} sm={12} md={6}>
                          <Box>
                            <Typography variant="cuerpo">
                              <b>Cantidad de folios:</b> {folio}
                            </Typography>
                          </Box>
                        </Grid>
                      ) : (
                          ""
                        )}
                      <Grid item xs={12}>
                        <Box>
                          <Typography variant="cuerpo">
                            <b>Situación:</b> {situacion}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>

          <Grid container justifyContent="space-between" spacing={0}>
            <Grid item align="left">
              <Typography variant="aclaracion" sx={{color:'#ED6C02'}}><b>{mensajeArhivado}</b></Typography>
            </Grid>
            <Grid
              item
              align="right"
              sx={{ display: { xs: "none", md: "inline" } }}
            >
              <Box align="right">
                <Button
                  variant="plata"
                  onClick={handleCloseNuevoAgregado}
                  endIcon={<ClearIcon />}
                  sx={{ m: 1 }}
                >
                  {"Cancelar"}
                </Button>
                <Button
                  sx={{ m: 1 }}
                  variant="verde"
                  color="primary"
                  type="submit"
                  disabled={submitting}
                  endIcon={<DoneOutlineRounded />}
                >
                  {submitting ? "Confirmar" : "Confirmar"}
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "block", md: "none" } }}
            >
              <IconButton color="primary" onClick={handleCloseNuevoAgregado} title="Cancelar">
                <ClearIcon />
              </IconButton>{" "}
              <IconButton
                color="primary"
                type="submit"
                disabled={submitting}
                title="Confirmar"
              >
                <DoneOutlineRounded />
              </IconButton>
            </Grid>
            <Grid item xs={12} sm={12}>
              {" "}
            </Grid>
          </Grid>
        </form>
      </Modal>

      <Modal open={openDesglosar} handleClose={handleCloseDesglosar} size="sm">
        <form
          id="formularioDesglosar"
          name="formularioDesglosar"
          onSubmit={formik2.handleSubmit}
          onReset={formik2.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} sx={{ marginBottom: 1 }}>
              <Typography variant="titulo">DESGLOSAR EL {tipo} NÚMERO <b>{numero}</b></Typography>
            </Grid>
            <Grid item lg={4} xs={12}>
              <TextField
                id="folios"
                name="folios"
                label="Folios"
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{ maxLength: 4 }}
                value={formik2.values.folios}
                onChange={handleChangeTextField2}
                error={formik2.touched.folios && Boolean(formik2.errors.folios)}
                helperText={formik2.touched.folios && formik2.errors.folios}
              />
            </Grid>
            <Grid item lg={12} xs={12}>
              <Typography
                variant="aclaracion"
                sx={{
                  display: {
                    xs: "inline",
                    sm: "inline",
                    md: "inline",
                    lg: "inline",
                  },
                }}
              >
                Cantidad de folios con las que queda el {aclaracion} secundario
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "none", md: "inline" } }}
            >
              <Button
                variant="plata"
                onClick={handleCloseDesglosar}
                endIcon={<ClearIcon />}
                sx={{ m: 1 }}
              >
                {"Cancelar"}
              </Button>
              <Button
                sx={{ m: 1 }}
                variant="verde"
                color="primary"
                type="submit"
                disabled={submitting2}
                endIcon={<DoneOutlineRounded />}
              >
                {submitting2 ? "Desglosando..." : "Desglosar"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Modal>
      {verifica ? (
            <VerificarUltimoAdjunto
              tramiteId = {props.id}
              verficarElFirmado={verficarElFirmado}
              verficarElFirmadoCancelar={verficarElFirmadoCancelar}
            >
      </VerificarUltimoAdjunto>):(null)}
      {verificaDesglose? (
            <VerificarUltimoAdjunto2
              tramiteId = {props.id}
              verficarElFirmado={verficarElFirmado2}
              verficarElFirmadoCancelar={verficarElFirmadoCancelar2}
            >
      </VerificarUltimoAdjunto2>):(null)}     
      <Modal
        open={openObservacion}
        handleClose={handleCloseObservacion}
        size="sm"
      >
        <Typography variant="titulo" paragraph>
          OBSERVACION
        </Typography>
        <Typography variant="cuerpo" paragraph>
          {observacion}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button
            sx={{ m: 1 }}
            variant="plata"
            onClick={handleCloseObservacion}
          >
            {"Cerrar"}
          </Button>
        </Box>
      </Modal>
    </Grid >
  );
};

export default Agregados;